import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatRippleModule,
  MatTooltipModule
} from '@angular/material';

import { UploadDocumentPhotoComponent } from './upload-document-photo.component';
import { DropZoneDirective } from './drop-zone.directive';
import { ConfirmationDialogModule } from '@ui/confirmation-dialog';
import { UiErrorsModule } from '@ui/ui-errors';

@NgModule({
  declarations: [
    UploadDocumentPhotoComponent,
    DropZoneDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ConfirmationDialogModule,
    UiErrorsModule
  ],
  providers: [],
  exports: [
    UploadDocumentPhotoComponent,
    DropZoneDirective
  ]
})
export class UploadDocumentPhotoModule {
}
